import PropTypes from 'prop-types';

const intlShape = PropTypes.shape({
  formatMessage: PropTypes.func.isRequired,
});

export default intlShape;
